import DepositBonus1 from "../../assets/images/banner/promotions/welcomeBonusonCasino.jpeg";
import DepositBonus2 from "../../assets/images/banner/promotions/welcomeBonus.jpeg";
import DepositBonus3 from "../../assets/images/banner/promotions/weeklybonus.jpeg";
import DepositBonus4 from "../../assets/images/banner/promotions/weeklycashback.jpeg";
import DepositBonus5 from "../../assets/images/banner/promotions/netwallet.jpeg";

export const modalsData = [
  {
    id: 1,
    title: "Welcome Bonus on Casino",
    imgSrc: DepositBonus1,
    introTitle: "Welcome Bonus on Casino",
    terms: [
      "Get 100% bonus on sports on your first deposit up to 1,00,000 INR",
      "Casino bonus must be wagered 30 times on live casino and slots games.",
      "Your profile must be fully completed before claiming the bonus.",
      'The bonus must be claimed before making the deposit from the "Bonus" section in your profile.',
      "Withdrawals are not allowed until the bonus amount has been fully wagered.",
      "You may cancel the bonus at any time to proceed with a withdrawal; however, doing so will result in forfeiting any winnings earned from the bonus.",
      "Once the wagering requirement is met, funds will automatically move from the bonus wallet to the main wallet.",
      "Only one bonus can be claimed at a time. You must complete, cancel, or forfeit an active bonus before claiming a new one.",
      "Bonus will be valid for 30 days from the date of credit. If the wagering requirements are not fulfilled within this period, the bonus and any associated winnings will be forfeited.",
      "Only one user per IP address, household, device, or shared network is allowed to claim the bonus.",
      "Indi365 reserves the right to cancel or modify the bonus offer at any time without prior notice.",
      "Indi365 reserves the right to exclude any user found misusing or abusing the promotion. In such cases, winnings may be forfeited and accounts may be permanently banned.",
    ],
    actionButton: true,
  },
  {
    id: 2,
    title: "First Deposit Bonus",
    imgSrc: DepositBonus2,
    introTitle: "First Deposit Bonus",
    terms: [
      "Users will get a First Deposit Bonus of 100% on their First Deposit with Up to a bonus amount of 1,00,000 INR",
      "Users have to wager the bonus amount 5 Times on Sports with bets placed on or above odds of 1.50",
      "Users have to wager the bonus amount 30 Times on the Casino, Live Casino, or Slots",
      "Before depositing the First Deposit, the user needs to activate the First Deposit Bonus under the bonuses section from their INDI365 Player ID",
      "The bonus will be valid for 30 Days from the date of acceptance",
      "If the user is unable to withdraw their deposit wallet balance other than the bonus balance, they must cancel the bonus.",
      "However, please note that doing so will result in the loss of all bonus balance associated with their account.",
    ],
    actionButton: false,
  },
  {
    id: 3,
    title: "Weekly Sports Cashback Bonus",
    imgSrc: DepositBonus3,
    introTitle: "Weekly Sports Cashback Bonus",
    terms: [
      "Weekly Sports Cashback Bonus of 10% Will Be Added to Users on Every Monday Weekly Period",
      "The Bets Which Have Been Settled According to That Cashback Will Be Calculated",
      "The Sports Cashback Bonus Will Be Automatically Added to Player ID Till 3PM IST",
      "User Needs to 2X Wagering of Sports Cashback Bonus to Take the Cashback Balance Into Main Wallet",
    ],
    actionButton: false,
  },
  {
    id: 4,
    title: "Weekly Cashback On Casino/Live Casino/Slots",
    imgSrc: DepositBonus4,
    introTitle: "Weekly Cashback On Casino/Live Casino/Slots",
    terms: [
      "Weekly Casino Cashback Bonus of 10% Will Be Added to Player ID on Every Monday on Weekly Period",
      "Weekly Live Casino Cashback of 10% Will Be Added to Player ID on Every Monday on Weekly Period",
      "The Casino and Live Casino Cashback Will Be Automatically Added to Player ID Between 10:00 AM IST - 11:30 AM IST on Monday",
      "Ineligible Slot Providers - Smartsoft, Zeus Play, One Touch, Inbet Games, etc.",
      "Ineligible Live Casino Game Types - Baccarat, Dragon Tiger, Sic Bo",
      "Betting Games Are Not Eligible for Cashback Bonus Programme (Aviatrix, Slot Games, Sic Bo, etc.)",
      "Users Can Directly Withdraw the Cashback Bonuses",
    ],
    actionButton: false,
  },
  {
    id: 5,
    title: "5% on Netwallet Deposit",
    imgSrc: DepositBonus5,
    introTitle: "5% on Netwallet Deposit",
    terms: [
      "Deposit a minimum of ₹1000 or more to get a 5% bonus on your first deposit with Netwallet.",
      "Your profile must be fully completed before claiming the bonus.",
      'The bonus must be claimed before making the deposit, from the "Bonus" section in your profile.',
      "If the above conditions are met, the bonus will be credited automatically to your bonus wallet upon deposit.",
      "You must select the bonus wallet while placing bets to use bonus funds.",
      "Sports bonus must be wagered 5 times on bets with minimum odds of 1.5.",
      "Casino bonus must be wagered 30 times before becoming eligible for withdrawal.",
      "Withdrawals are not allowed until the bonus amount has been fully wagered.",
      "You may cancel the bonus at any time to proceed with a withdrawal; however, doing so will result in forfeiting any winnings earned from the bonus.",
      "Once the wagering requirement is met, funds will automatically move from the bonus wallet to the main wallet.",
      "Only one bonus can be claimed at a time. You must complete, cancel, or forfeit an active bonus before claiming a new one.",
      "Bonus will be valid for 30 days from the date of credit. If the wagering requirements are not fulfilled within this period, the bonus and any associated winnings will be forfeited.",
      "Only one user per IP address, household, device, or shared network is allowed to claim the bonus.",
      "Indi365 reserves the right to cancel or modify the bonus offer at any time without prior notice.",
      "Indi365 reserves the right to exclude any user found misusing or abusing the promotion. In such cases, winnings may be forfeited and accounts may be permanently banned.",
    ],
    actionButton: false,
  },
];
